import { post, put } from '..';
import { TemplateField, TemplateIssue, TemplateType } from '../../constants/Types';

type UpdateTemplateBody = {
  Name: string,
  GroupId: string,
  GroupName: string,
  Issues: TemplateIssue[],
  Fields: TemplateField[],
  Type: TemplateType,
  PpmUrl?: string,
  ButtonPrototypeId?: string,
  Title: string | null,
  Subtitle: string | null,
  SubtitleUrl?: string | null,
  disablePhotoUpload: boolean,
}

const updateTemplate = ({
  Name, GroupId, GroupName, Issues, Fields, Type, PpmUrl, ButtonPrototypeId: id, Title, Subtitle,
  SubtitleUrl, disablePhotoUpload,
}: UpdateTemplateBody) => {
  const body: UpdateTemplateBody = {
    Name,
    GroupId,
    GroupName,
    Issues,
    Fields,
    Type,
    Title,
    Subtitle,
    SubtitleUrl,
    disablePhotoUpload,
  };
  if (PpmUrl) body.PpmUrl = PpmUrl;

  if (id) {
    body.ButtonPrototypeId = id;
    return put('templates', body);
  }

  return post('templates', body);
};

export default updateTemplate;
